export const transformSnakeCaseToPascalCase = (str: string) =>
  str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const transformSentenceToKebabCase = (str: string) =>
  str
    .trim()
    .toLowerCase()
    .replace(/[\s,.&]+/g, '-')
    .replace(/[^a-z0-9-]/g, '');

export const transformSnakeCaseToTitleCase = (str: string) =>
  str
    .split('_')
    .map((word) => {
      if (/[A-Z]/.test(word)) {
        return word;
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
